export default "__VITE_ASSET__BGYVcLO___"